import { gql } from '@apollo/client/core';

export const getGroupEnrollmentQuery = gql`
  query GetGroupEnrollment($seqNo: Int!) {
    groupEnrollment(seqNo: $seqNo) {
      actionNotes
      agreementApprovedDate
      agreementDeniedDate
      agreementSentDate
      agreementSubmittedDate
      caseNumber
      dateLastDbUpdate
      dateSetup
      ediId
      enrollmentId
      enrollmentOwner
      enrollmentStatus
      enrollmentType
      followUpDate
      id
      lastUpdatedBy
      message
      notes
      npi
      payerId
      pMS
      processorId
      seqNo
      taxId
      useApi
      payer {
        name
      }
      providerGroup {
        name
      }
      #provider: Provider
      #This is the provider associated to this groupenrollment.
      #providerGroup: ProviderGroup
      #This is the provider group associated to this groupenrollment.
    }
  }
`;

export const getGroupEnrollmentsQuery = gql`
  query GetGroupEnrollment(
    $first: Int!
    $where: GroupEnrollmentFilterInput
    $order: [GroupEnrollmentSortInput!]
    $after: String
  ) {
    groupEnrollments(
      first: $first
      where: $where
      order: $order
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      nodes {
        actionNotes
        agreementApprovedDate
        agreementDeniedDate
        agreementSentDate
        agreementSubmittedDate
        caseNumber
        dateLastDbUpdate
        dateSetup
        ediId
        enrollmentId
        enrollmentOwner
        enrollmentStatus
        enrollmentType
        followUpDate
        id
        lastUpdatedBy
        message
        notes
        npi
        payerId
        pms
        processorId
        payer {
          apg
          attachmentEnrollment
          attachments
          attachmentType
          batchClaimStatus
          billingIndicator
          cardId
          city
          claimFilingIndicator
          claimStatus
          claimStatusEnrollment
          claimStatusId
          claimStatusType
          contactEmail
          contactFax
          contactName
          contactPhone
          dateLastDbUpdate
          dateLastFile
          dateLastStatement
          dateSetup
          dateTerminate
          dentalProcessorId
          doesEligibility
          eligibilityEnrollment
          eligibilityType
          eraEnrollment
          eraType
          followUpNumberOfDays
          groupEnrolled
          #groupEnrollments
          icd10
          icd10EffectiveDate
          id
          institutionalEnrollment
          institutionalType
          legacy
          name
          neicId
          neicOffice
          neicPayerType
          nexia
          notes
          npiIndicator
          payorState
          payorType
          #preferredRoutings
          processorId
          publishEra
          publishInstitutional
          publishProfessional
          realTimeId
          recordStatus
          requiresEnrollment
          secondaryClaims
          state
          ubProcessorId
          webUrl
          zipCode
        }
        provider {
          # account: Account
          accountNumber
          addressCity
          addressLine1
          addressLine2
          addressState
          addressZipcode
          # application: Application
          billingMethod
          certified
          claimRoutingMethod
          claimStatusDate
          claimStatusStatus
          contactEmail
          contactFax
          contactName
          contactPhone
          contactTitle
          dateLastCertified
          dateLastClaim
          dateLastDbUpdate
          dateLastStatement
          dateSetup
          dateTerminate
          degree
          ecsDate
          ecsStatus
          eligibilityDate
          eligibilityStatus
          eraDate
          eraStatus
          feeSchedule
          firstName
          # groupEnrollments: [GroupEnrollment]
          id
          lastName
          lastUpdatedBy
          mailboxId
          mi
          neicId
          neicSiteId
          notes
          nsfBatchNumber
          organizationName
          organizationType
          pcMemory
          pms
          pmsSoftware
          # providerGroup: ProviderGroup
          providerGroupId
          recordStatus
          statementDate
          statementMethod
          statementStatus
          submitterNumber
        }
        providerGroup {
          #account
          accountNumber
          addressCity
          addressLine1
          addressLine2
          addressState
          addressZipcode
          alphaII
          appSenderCode
          backLink
          batch277ca
          batch277u
          batchCSV
          batchHumanReadable
          batchMachineReadable
          batchXml
          #billingIds: [BillingIds]
          billingMethod
          certified
          claimStatusDate
          claimStatusStatus
          clientVersion
          combineERA
          contactEmail
          contactFax
          contactName
          contactPhone
          contactTitle
          dateLastCertified
          dateLastClaim
          dateLastDbUpdate
          dateSetup
          dateTerminated
          ecsDate
          ecsStatus
          eligibilityDate
          eligibilityStatus
          eraDate
          eraFileSeqNum
          eraStatus
          # fees: Fee
          feeSchedule
          ftpKey
          glueEM
          # groupEnrollments: [GroupEnrollment]
          groupId
          humanReadable271
          inputGenerates999
          instAppSenderCode
          instNM109IdCode
          instProcessorId
          instSubmitterId
          interchangeNum
          lastUpdatedBy
          lockBox
          lockboxProcessorId
          mailboxId
          name
          newStatements
          nm109IdCode
          notes
          organizationType
          pmIdentifier
          pms
          pmsSoftware
          processorId
          #providers: [Provider]
          recordStatus
          rejectPrintClaims
          remit277ca
          remit277u
          remitCsv
          remitCSVDaily
          remitEraSummary
          remitHumanReadable
          remitMachineReadable
          remitXml
          reportNumber
          statementDate
          statementMethod
          statementStatus
          submitterId
          universalReport
          # usersClientsGrps: [UsersClientsGrps]
        }
        seqNo
        taxId
        useApi
      }
    }
  }
`;

export const getGroupEnrollmentStatuses = gql`
  query GetGroupEnrollmentStatuses(
    $where: EnrollmentStatusFilterInput
    $order: [EnrollmentStatusSortInput!]
  ) {
    enrollmentStatuses(where: $where, order: $order) {
      code
      description
    }
  }
`;

export const getGroupEnrollmentLogQuery = gql`
  query GetGroupEnrollment(
    $seqNo: Int!
    $first: Int!
    $where: EnrollmentLogFilterInput
    $order: [EnrollmentLogSortInput!]
    $after: String
  ) {
    enrollmentLogs(
      seqNo: $seqNo
      first: $first
      where: $where
      order: $order
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        seqNo
        status
        updated
        userId
        userName
      }
    }
  }
`;

export const getBillingIdListQuery = gql`
  query getBillingIdList(
    $where: BillingIdsFilterInput
    $order: [BillingIdsSortInput!]
  ) {
    billingIds(where: $where, order: $order) {
      nodes {
        billingId
      }
    }
  }
`;
